module.exports = __webpack_public_path__ + "static/media/header.89c39e1e.webm";